import api from '.';

export interface CreateAccessControl {
  projectDocumentId: number;
  userIds: number[];
}

export async function getProjectDocumentCustomAccessControls(
  projectDocumentId: number
) {
  const params = { projectDocumentId };
  const { data } = await api.get('/project-document-custom-access-controls', {
    params
  });
  return data;
}

export async function createProjectDocumentCustomAccessControls({
  projectDocumentId,
  userIds
}: CreateAccessControl) {
  const { data } = await api.post('/project-document-custom-access-controls', {
    projectDocumentId,
    userIds
  });
  return data;
}

export function deleteProjectDocumentCustomAccessControl(id: number) {
  return api.delete(`/project-document-custom-access-controls/${id}`);
}
